"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var Kalendae = require("kalendae");
var moment_timezone_1 = require("moment-timezone");
var React = require("react");
var Button_1 = require("../Button/Button");
var monitoring_1 = require("../../services/monitoring");
var classNames = require("classnames");
var Icon_1 = require("../Icon/Icon");
var DatePickerType = {
    BUTTON: 'button',
    INPUT: 'input'
};
var DatePicker = /** @class */ (function (_super) {
    __extends(DatePicker, _super);
    function DatePicker(props) {
        var _this = _super.call(this, props) || this;
        _this.isControlled = null;
        _this.DEFAULT_DISPLAY_DATE_FORMAT = 'MMM DD, YYYY';
        _this.getDateInTimezone = function (date, timezone) {
            return moment_timezone_1.tz({
                M: date.month(),
                d: date.date(),
                y: date.year()
            }, timezone);
        };
        _this.getDisplayDateFormat = function () {
            return _this.props.displayDateFormat || _this.DEFAULT_DISPLAY_DATE_FORMAT;
        };
        _this.getDatePickerType = function () {
            return _this.props.datePickerType || DatePickerType.INPUT;
        };
        _this.bindRootElement = function (element) {
            _this.rootElement = element;
        };
        _this.bindCalendarElement = function (element) {
            _this.calendarElement = element;
        };
        _this.drawRangeCalendar = function (config) {
            _this.dateRangeInstance = new Kalendae(_this.calendarElement, config);
            _this.dateRangeInstance.subscribe('change', _this.handleDateRangeChanges);
        };
        _this.getAcceptableFromDate = function () {
            return _this.props.acceptableFromDate || _this.DEFAULT_ACCEPTABLE_FROM_DATE;
        };
        _this.getAcceptableToDate = function () {
            return _this.props.acceptableToDate || _this.DEFAULT_ACCEPTABLE_TO_DATE;
        };
        _this.defaultDateRangeBlackout = function (date) {
            return !date.startOf('day').isBetween(_this.getAcceptableFromDate().startOf('day'), _this.getAcceptableToDate().startOf('day'), null, '[]' // the '[]' signifies that the start and end dates should be inclusive. default is '()'
            );
        };
        _this.handleClick = function (event) {
            var target = event.target || event.srcElement;
            if (_this.rootElement &&
                !_this.rootElement.contains(target) &&
                _this.state.open) {
                _this.requestClose(event);
            }
        };
        _this.handleDateRangeChanges = function () {
            if (!_this.dateRangeInstance) {
                return;
            }
            var selectedDates = _this.dateRangeInstance.getSelectedRaw();
            if (_this.dateRangeConfig.mode === 'range') {
                if (selectedDates.length !== 2) {
                    return;
                }
                var newFromDate = _this.getDateInTimezone(selectedDates[0], _this.props.timezone);
                var newToDate = _this.getDateInTimezone(selectedDates[1], _this.props.timezone);
                if (_this.props.onChange) {
                    _this.props.onChange(newFromDate, newToDate);
                }
            }
            else if (_this.dateRangeConfig.mode === 'single') {
                if (selectedDates.length !== 1) {
                    return;
                }
                var newFromDate = _this.getDateInTimezone(selectedDates[0], _this.props.timezone);
                if (_this.props.onChange) {
                    _this.props.onChange(newFromDate, newFromDate);
                }
            }
        };
        _this.toggle = function () {
            if (!_this.state.open) {
                _this.open();
            }
            else {
                _this.close();
            }
        };
        _this.open = function () {
            if (!_this.state.open) {
                _this.setState({ open: true });
            }
        };
        _this.requestClose = function (event) {
            if (!_this.state.open) {
                return;
            }
            // Always call prop
            _this.props.onClose && _this.props.onClose(event);
            // If uncontrolled, close the DatePicker
            if (!_this.isControlled) {
                _this.close();
            }
        };
        _this.close = function () {
            if (!_this.state.open) {
                return;
            }
            _this.setState({
                open: false
            });
        };
        _this.buildConfig = function (blackoutFunction) {
            return {
                blackout: blackoutFunction,
                mode: 'range',
                months: 2
            };
        };
        var today = moment_timezone_1.tz();
        _this.DEFAULT_ACCEPTABLE_FROM_DATE = _this.getDateInTimezone(today, _this.props.timezone);
        _this.DEFAULT_ACCEPTABLE_TO_DATE = _this.DEFAULT_ACCEPTABLE_FROM_DATE.clone().add({ y: 1 });
        var blackoutFunction = props.dateRangeBlackout
            ? _this.props.dateRangeBlackout
            : _this.defaultDateRangeBlackout.bind(_this);
        _this.dateRangeConfig = _this.props.dateRangeConfig
            ? _this.props.dateRangeConfig
            : _this.buildConfig(blackoutFunction);
        _this.state = {
            open: false
        };
        return _this;
    }
    DatePicker.prototype.componentDidMount = function () {
        monitoring_1.default('datePicker');
        if (!this.dateRangeInstance) {
            this.drawRangeCalendar(this.dateRangeConfig);
        }
        var selected = this.dateRangeInstance.getSelectedRaw();
        if (!selected || selected.length < 2) {
            this.dateRangeInstance.setSelected([
                this.props.fromDate.toDate(),
                this.props.toDate.toDate()
            ]);
        }
        this.dateRangeInstance.draw();
    };
    DatePicker.prototype.componentWillReceiveProps = function (props) {
        var blackoutFunction = props.dateRangeBlackout
            ? this.props.dateRangeBlackout
            : this.defaultDateRangeBlackout.bind(this);
        this.dateRangeConfig = this.props.dateRangeConfig
            ? this.props.dateRangeConfig
            : this.buildConfig(blackoutFunction);
        // If the DatePicker is controlled
        if (this.isControlled) {
            // If the open prop has changed, open or close the DatePicker
            if (props.open !== this.props.open) {
                if (props.open) {
                    this.open();
                }
                else {
                    this.close();
                }
            }
        }
    };
    DatePicker.prototype.componentWillMount = function () {
        var props = this.props;
        this.isControlled = props.open !== undefined;
        document.addEventListener('click', this.handleClick, false);
    };
    DatePicker.prototype.componentWillUnmount = function () {
        document.removeEventListener('click', this.handleClick);
    };
    DatePicker.prototype.render = function () {
        var _a = this.props, className = _a.className, style = _a.style;
        var dateFormat = this.getDisplayDateFormat();
        var dateString;
        switch (this.dateRangeConfig.mode) {
            case 'range':
                dateString = this.props.fromDate.format(dateFormat) + " - " + this.props.toDate.format(dateFormat);
                break;
            case 'single':
                dateString = "" + this.props.fromDate.format(dateFormat);
                break;
            default:
                break;
        }
        var OpeningElement;
        var TargetElement = this.props.attachTo ||
            (this.props.children && React.Children.only(this.props.children));
        if (TargetElement) {
            var openingElementProps = __assign({}, TargetElement.props, { dateString: dateString });
            if (!this.isControlled) {
                openingElementProps.onClick = this.toggle;
            }
            OpeningElement = React.cloneElement(TargetElement, openingElementProps);
        }
        else if (this.getDatePickerType() === DatePickerType.BUTTON) {
            OpeningElement = (React.createElement(Button_1.default, { onClick: this.toggle, buttonType: "tertiary" }, dateString));
        }
        else {
            var wrapperClassName = 'form-input';
            var errMsg = void 0;
            if (this.props.validationResult) {
                if (!this.props.validationResult.isValid) {
                    wrapperClassName += ' error';
                }
                errMsg = (React.createElement("span", { className: "form-error-message" }, this.props.validationResult.error));
            }
            OpeningElement = (React.createElement("div", { className: wrapperClassName },
                errMsg,
                React.createElement("input", { type: "text", onClick: this.toggle, readOnly: true, value: dateString }),
                React.createElement(Icon_1.default, { className: "date-picker__calendar-input", icon: "calendar", color: "nimbus" })));
        }
        var controlClassName = 'date-picker__control';
        if (!this.state.open) {
            controlClassName += " " + controlClassName + "--hidden";
        }
        var classes = classNames('date-picker', className);
        return (React.createElement("div", { className: classes, style: style, ref: this.bindRootElement },
            OpeningElement,
            React.createElement("div", { className: controlClassName },
                React.createElement("div", { className: "date-picker__control__range" },
                    React.createElement("div", { className: "date-picker__control__range__calendar", ref: this.bindCalendarElement })))));
    };
    return DatePicker;
}(React.Component));
exports.default = DatePicker;
//# sourceMappingURL=DatePicker.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/callahan-react/es/components/DatePicker/DatePicker.js
// module id = 240
// module chunks = 0